<template>
  <main class="auth">
    <div class="container">
      <div class="content-area">
        <nuxt/>
        <f-footer />
      </div>
    </div>
  </main>
</template>

<script>
  import {
      FFooter,
  } from '~/components/frontend';

  export default {
    name: 'frontend-auth-layout',
    head() {
      return {
        meta: [
          {charset: 'utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {hid: 'description', name: 'description', content: ''}
        ],
        link: [
          {rel: 'stylesheet', type: 'text/css', href: '/frontend/css/style.css'},
        ]
      }
    },
    components: {
      FFooter,
    }
  }
</script>
